export var getEmptySport = function () {
    var resultViewData = {
        id: "",
        name: "",
    };
    return resultViewData;
};
